import { render } from "./OTIFooter.vue?vue&type=template&id=9a1e454c"
import script from "./OTIFooter.vue?vue&type=script&lang=js"
export * from "./OTIFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/frankreinshome/Development/otiplayer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__